
import {computed, createVNode, defineComponent, onMounted, onUnmounted, ref, watch} from 'vue';
import {
  OioButton,
  OioDrawer,
  OioInputSearch,
  OioSpin,
  OioForm,
  OioFormItem,
  OioInput,
  OioInputNumber,
  OioSwitch,
  OioTextarea,
  OioDateTimePicker,
  OioNotification, OioRow, OioCol,

} from '@kunlun/vue-ui-antd';
import {renderTree} from './renderMap';
import {NodeConfig, TreeGraph, TreeGraphData} from '@antv/g6';
import {
  createConditionData,
  createPolicyData,
  rootNodeData,
  createActivityTypeData,
  createRightsInfoData,
  createSimpleConditionData,
  createConditionRowJsonData,
  TNodeData
} from './templateData';
import {actionBarHeight, conditionRowHeight, CustomNodeType} from './nodes';
import {FormInstance, message, Modal} from 'ant-design-vue';
import {ExclamationCircleOutlined} from '@ant-design/icons-vue';
import {
  activityTypeOptions,
  directSubRuleOperationOptions,
  fullGwpRightsOperationOptions,
  fullGwpTimesOptions,
  fullMoneyOptions,
  fullOptionsValueMap,
  fullPkgOptions,
  fullSubRightsOperationOptions,
  fullSubTimesOptions,
  fullTypeOptions,
  rightsOperationsOptionsKeyMap,
  rightsOperationsTimesOptionsKeyMap,
  SECKILLRightsOperationOptions,
  startPkgOptions
} from './options';
import {cloneDeep, debounce} from 'lodash-es';
import {OioColorPicker} from "@kunlun/vue-ui-el";

export default defineComponent({
  name: 'MindMap',
  components: {
    OioCol,
    OioColorPicker,
    OioRow,
    OioButton,
    OioDrawer,
    OioInputSearch,
    OioSpin,
    OioForm,
    OioFormItem,
    OioInput,
    OioInputNumber,
    OioSwitch,
    OioTextarea,
    OioDateTimePicker
  },
  props: ['setTreeGraph', 'merchBill', 'submitTree', 'treeData', 'rowData', '_formData', 'baseData'],
  setup(props, ctx) {
    const activeNode = ref<NodeConfig & Record<string, any>>();
    let activeConditionIndex = -1;
    let newGroup_uniqueIds: string[] = [];

    let treeGraph: TreeGraph | undefined;
    const canGroup = ref(false);
    const showLinkModal = ref(false);
    const searchLinkStr = ref('');
    const searchLinkLoading = ref(false);
    const selectedLinkName = ref('');
    const showLinkList = ref<any[]>([]);
    const showPolicyModal = ref(false);
    const policyFormRef = ref<FormInstance>();
    const showRightsSettingModal = ref(false);
    const rightsSettingsFormRef = ref<FormInstance>();
    const isFullScreen = ref(false);
    let copyLinkList: any[] = [];
    let selectionStart = 0;
    let selectionEnd = 0;
    let lastMode = '';

    const showAdvanceSetting = computed(() => {
      if (
          activeNode.value?.type === CustomNodeType.RIGHTS_INFO &&
          props.rowData[activeNode.value!.dataId].equityInformationRule.reductionOption === 'DISCOUNT_RATE'
      ) {
        return true;
      }
      return false;
    });

    const showRealPrice = computed(() => {
      return (
          [CustomNodeType.RIGHTS_INFO, CustomNodeType.SIMPLE_RIGHTS_INFO].includes(activeNode.value?.type ?? '') &&
          ['FULL_SUB'].includes(props.rowData[activeNode.value!.dataId]?.optionType ?? '')
      );
    });

    const showOnePrice = computed(() => {
      return (
          [CustomNodeType.RIGHTS_INFO, CustomNodeType.SIMPLE_RIGHTS_INFO].includes(activeNode.value?.type ?? '') &&
          ['FULL_SUB'].includes(props.rowData[activeNode.value!.dataId]?.optionType ?? '')
      );
    });

    const handleTimeRuleChange = (value) => {
      if (value === undefined) {
        props.rowData[activeNode.value!.dataId].policyInfo.accountTimeRule = '';
        props.rowData[activeNode.value!.dataId].policyInfo.paymentDays = '';
        props.rowData[activeNode.value!.dataId].policyInfo.accountDate = '';
      }
    };

    const promotionTypeChange = (value) => {
      if(value === 'ZFD2' || value === 'ZTJ1' || value === 'ZFD4' || value === 'ZFD6') {
        props.rowData[activeNode.value!.dataId].policyInfo.platformDiscount = 100.00;
        props.rowData[activeNode.value!.dataId].policyInfo.provinceDiscount = 0.00;
        props.rowData[activeNode.value!.dataId].policyInfo.productDiscount = 0.00;
      }
      else{
        props.rowData[activeNode.value!.dataId].policyInfo.platformDiscount = 0.00;
        props.rowData[activeNode.value!.dataId].policyInfo.provinceDiscount = 100.00;
        props.rowData[activeNode.value!.dataId].policyInfo.productDiscount = 0.00;
      }
    }

    const limitNum = (e) => {
      let val = e.target.value;
      // 限制输入正整数
      if (val && !/^[0-9]\d*?$/.test(val)) {
        val = val.slice(0, -1);
      }
      props.rowData[activeNode.value!.dataId].policyInfo.paymentDays = val;
    };

    const validatePlatformDiscount = (rule: any, value: any, callback: any) => {
      
      console.log(value);
      if(props.rowData[activeNode.value!.dataId].policyInfo.provinceDiscount == undefined || props.rowData[activeNode.value!.dataId].policyInfo.productDiscount == undefined)
      {
        return  Promise.resolve();
      }
      if((+value) + (+props.rowData[activeNode.value!.dataId].policyInfo.provinceDiscount) + (+props.rowData[activeNode.value!.dataId].policyInfo.productDiscount) != 100)
        return  Promise.reject('让利总和必须为100');
      else
        return  Promise.resolve();
    };

    const validateProvinceDiscount = (rule: any, value: any, callback: any) => {
      
      console.log(value);
      if(props.rowData[activeNode.value!.dataId].policyInfo.platformDiscount == undefined || props.rowData[activeNode.value!.dataId].policyInfo.productDiscount == undefined)
      {
        return  Promise.resolve();
      }
      if((+value) + (+props.rowData[activeNode.value!.dataId].policyInfo.platformDiscount) + (+props.rowData[activeNode.value!.dataId].policyInfo.productDiscount) != 100)
        return  Promise.reject('让利总和必须为100');
      else
        return  Promise.resolve();
    };

    const validateProductDiscount = async (rule: any, value: any, callback: any) => {
      
      console.log(value);
      if(props.rowData[activeNode.value!.dataId].policyInfo.provinceDiscount == undefined || props.rowData[activeNode.value!.dataId].policyInfo.platformDiscount == undefined)
      {
        return  Promise.resolve();
      }
      if((+value) + (+props.rowData[activeNode.value!.dataId].policyInfo.provinceDiscount) + (+props.rowData[activeNode.value!.dataId].policyInfo.platformDiscount) != 100)
        return  Promise.reject('让利总和必须为100');
      else
        return  Promise.resolve();
    };

    const mousedownHandler = (e) => {
      // 输入框或者文本框时不触发拖拽
      if (['INPUT', 'TEXTAREA'].includes((e.target as any).nodeName)) {
        lastMode = treeGraph!.getCurrentMode();
        treeGraph!.setMode('none');
      }
    };

    const mouseupHandler = (e) => {
      if (treeGraph?.getCurrentMode() === 'none') {
        treeGraph!.setMode(lastMode);
      }
    };

    onMounted(() => {
      document.querySelector('#mountNode')?.addEventListener('mousedown', mousedownHandler);
      document.body.addEventListener('mouseup', mouseupHandler);
    });

    const updateTree = () => {
      const oldTranslate = treeGraph!.get('group').getMatrix();
      treeGraph!.changeData(treeGraph!.getNodes()[0].getModel());
      treeGraph!.get('group').setMatrix(oldTranslate);
    };

    // 检查关联商品数据是否存在于当前修改的商品清单中
    const checkRelateName = (linkList) => {
      const allData = treeGraph?.getNodes();
      let hasChange = false;
      allData?.forEach((i) => {
        const node = i.getModel();
        const nodeJsonData = props.rowData[i.getModel().dataId as string] as any;
        // 前置条件关联商品清单
        if (node.type === CustomNodeType.CONDITIONS && node.isPre) {
          const diffIndexArr: number[] = [];
          nodeJsonData.conditions.forEach((i, index) => {
            if (i.promotionItemStr && linkList.every((a) => a.merchBillName !== i.promotionItemStr)) {
              diffIndexArr.push(index);
            }
          });
          if (diffIndexArr.length) {
            hasChange = true;
            diffIndexArr.forEach((i) => {
              nodeJsonData.conditions[i].promotionItemStr = '';
            });
          }
        }
        // 促销政策关联商品清单
        if (node.type === CustomNodeType.POLICY) {
          if (
              nodeJsonData.promotionItemStr &&
              linkList.every((i) => i.merchBillName !== nodeJsonData.promotionItemStr)
          ) {
            hasChange = true;
            nodeJsonData.promotionItemStr = '';
          }
        }
        // 权益信息关联商品清单
        if (node.type === CustomNodeType.RIGHTS_INFO) {
          if (
              nodeJsonData.equityInformationRule.equityInfoItemStr &&
              linkList.every((i) => i.merchBillName !== nodeJsonData.equityInformationRule.equityInfoItemStr)
          ) {
            hasChange = true;
            nodeJsonData.equityInformationRule.equityInfoItemStr = '';
          }
        }
      });

      treeGraph?.layout();

      if (hasChange) {
        Modal.warn({
          getContainer: () => document.getElementById('mountNode')!,
          class: 'oio-modal',
          title: '当前修改的商品清单涉及活动设计，系统已为您重置，请前往重新设置。',
          icon: createVNode(ExclamationCircleOutlined),
          okText: '前往设置',
          onOk() {
            document.querySelector('#g6_map_content')?.scrollIntoView({
              behavior: 'smooth', // 可选，设置为 'smooth' 会产生平滑滚动效果
              block: 'start',
              inline: 'nearest'
            });
          }
        });
      }
    };

    // 商品清单
    watch(
        () => props.merchBill,
        (val) => {
          // 第一次修改以后才检查
          if (showLinkList.value) {
            checkRelateName(val);
          }
          showLinkList.value = val;
          copyLinkList = val;
        },
        {deep: true}
    );

    // 编辑或者还原时处理活动叠加
    const dealActivityPriority = () => {
      const policyFirstChildNodes = treeGraph!
          .getNodes()
          .filter((i) => i.getModel().type === CustomNodeType.POLICY && (i.getModel().children as any[]).length)
          .map((i: any) => i.getModel().children[0]);
      policyFirstChildNodes.forEach((i) => {
        collectPriorities(i);
      });
      treeGraph!.layout();
    };

    const msgHandler = (e) => {
      if (e.data === 'ActivityFillData') {
        // 处理活动叠加
        dealActivityPriority();
      } else if (e.data === 'init-tree-graph') {
        treeGraph?.destroy();
        treeGraph = undefined;
        console.time('初始化');
        treeGraph = renderTree('mountNode', props.treeData || rootNodeData({rowData: props.rowData}), props.rowData);
        props.setTreeGraph(treeGraph);
        console.timeEnd('初始化');

        if (props.treeData) {
          console.time('处理活动叠加');
          // 处理活动叠加
          dealActivityPriority();
          console.timeEnd('处理活动叠加');
        }
      }
    };

    const resizeHandler = () => {
      const isFull = document.fullscreenElement;
      if (!isFull) {
        isFullScreen.value = false;
      }
    };

    window.addEventListener('message', msgHandler);
    window.addEventListener('resize', resizeHandler);
    onUnmounted(() => {
      window.removeEventListener('message', msgHandler);
      window.removeEventListener('resize', resizeHandler);
      document.querySelector('#mountNode')?.removeEventListener('mousedown', mousedownHandler);
      document.body.removeEventListener('mouseup', mouseupHandler);
    });

    watch(showLinkModal, (val) => {
      if (val) {
        showLinkList.value = cloneDeep(copyLinkList);
      }
    });

    watch(isFullScreen, (val) => {
      const ele = document.querySelector('#g6_map_content');
      if (ele) {
        // 进入全屏
        if (val) {
          message.config({
            getContainer: () => document.querySelector('#mountNode')!
          });
          ele.requestFullscreen().catch((err) => console.error(err));
          treeGraph!.setMode('custom');
        }
        // 退出全屏
        else {
          if (document.fullscreenElement) {
            message.config({
              getContainer: () => document.body
            });
            document.exitFullscreen();
          }
          treeGraph!.setMode('default');
        }
      }
    });

    const interval = setInterval(() => {
      if (activeNode.value) {
        clearInterval(interval);
        watch(
            () => props.rowData[activeNode.value!.dataId].policyInfo,
            (val) => {
              if (val && props.rowData[activeNode.value!.dataId].level === 2) {
                const node = treeGraph!.findDataById(activeNode.value!.id)!;
                (props.rowData[node.dataId as string] as any).name = val.name;
              }
            },
            {
              deep: true
            }
        );
      }
    }, 200);

    // 关联商品清单关闭事件
    const onLinkModalClose = async () => {
      showLinkModal.value = false;
      searchLinkStr.value = '';
    };

    // 权益信息配置-高级配置开启/关闭
    const onRightsAdvancedChange = (checked) => {
      if (checked) {
        props.rowData[activeNode.value!.dataId].equityInformationRule.realPriceNotBenefits = false;
        props.rowData[activeNode.value!.dataId].equityInformationRule.buyItNotBenefits = false;
      } else {
        props.rowData[activeNode.value!.dataId].equityInformationRule.advanceItemStr = '';
      }
    };

    // 促销政策配置关闭事件
    const onPolicyModalClose = async () => {
      await policyFormRef.value!.validate();
      const record = props.rowData[activeNode.value!.dataId];

      if (record.policyInfo.accountTimeRule === 'DELIVERY_TIME' && record.policyInfo.paymentDays < 1) {
        OioNotification.error('错误', '指定账期天数必须大于0!');
        return;
      }

      showPolicyModal.value = false;
      treeGraph!.layout();
    };

    // 权益信息弹窗关闭
    const onRightsSettingClose = async () => {
      await rightsSettingsFormRef.value!.validate();

      showRightsSettingModal.value = false;
      treeGraph!.layout();
    };

    // 搜索关联商品清单
    const onLinkSearch = async () => {
      try {
        searchLinkLoading.value = true;
        showLinkList.value = props.merchBill.filter((i) => i.merchBillName.includes(searchLinkStr.value));
      } catch (error) {
        console.error(error);
      } finally {
        searchLinkLoading.value = false;
      }
    };

    // 选择关联商品清单
    const onLinkChange = (e) => {
      const node = treeGraph!.findDataById(activeNode.value!.id)! as TNodeData;
      const value = e.target.value;
      // 前置条件关联商品清单
      if (activeNode.value!.type === CustomNodeType.CONDITIONS) {
        if (props.rowData[node.dataId].conditions[activeConditionIndex].promotionItemStr !== value) {
          props.rowData[node.dataId].conditions[activeConditionIndex].promotionItemStr = value;
        } else {
          props.rowData[node.dataId].conditions[activeConditionIndex].promotionItemStr = '';
          selectedLinkName.value = '';
        }
      }
      // 促销政策关联商品清单
      else if (activeNode.value!.type === CustomNodeType.POLICY) {
        if (props.rowData[node.dataId].promotionItemStr !== value) {
          props.rowData[node.dataId].promotionItemStr = value;
        } else {
          props.rowData[node.dataId].promotionItemStr = '';
          selectedLinkName.value = '';
        }
      }
      // 权益信息
      else if (activeNode.value!.type === CustomNodeType.RIGHTS_INFO) {
        if (props.rowData[node.dataId].equityInformationRule.equityInfoItemStr !== value) {
          props.rowData[node.dataId].equityInformationRule.equityInfoItemStr = value;
        } else {
          props.rowData[node.dataId].equityInformationRule.equityInfoItemStr = '';
          selectedLinkName.value = '';
        }
      }
      treeGraph!.layout();
    };

    // 权益信息-选择关联商品清单
    const onRightsLinkChange = (e) => {
      const node = treeGraph!.findDataById(activeNode.value!.id)! as TNodeData;
      const value = e.target.value;

      if (props.rowData[node.dataId].equityInformationRule.advanceItemStr !== value) {
        props.rowData[node.dataId].equityInformationRule.advanceItemStr = value;
      } else {
        props.rowData[node.dataId].equityInformationRule.advanceItemStr = '';
      }

      treeGraph!.layout();
    };

    const onGroup = (type: string) => {
      const node = treeGraph!.findDataById(activeNode.value!.id)! as TNodeData;
      const conditionData = props.rowData[node!.dataId][activeNode.value!.isPre ? 'conditions' : 'effectConditions'];

      // 移除当前组合中单行组合数据
      const newGroups: any[] = [];
      props.rowData[node.dataId][
          activeNode.value!.isPre ? 'conditionsCombine' : 'effectConditionsCombine'
          ].groups.forEach((i) => {
        if ((i._uniqueIds.length === 1 && !newGroup_uniqueIds.includes(i._uniqueIds[0])) || i._uniqueIds.length > 1) {
          newGroups.push(i);
        }
      });
      // 当前多行组合新数据
      newGroups.unshift({
        _uniqueIds: newGroup_uniqueIds,
        type
      });
      props.rowData[node!.dataId][activeNode.value!.isPre ? 'conditionsCombine' : 'effectConditionsCombine'].groups =
          newGroups;

      // 重新排序以便进行组合
      const newConditions: any[] = [];
      for (
          let a = 0;
          a <
          props.rowData[node.dataId][activeNode.value!.isPre ? 'conditionsCombine' : 'effectConditionsCombine'].groups
              .length;
          a++
      ) {
        const group_uniqueIds =
            props.rowData[node.dataId][activeNode.value!.isPre ? 'conditionsCombine' : 'effectConditionsCombine'].groups[
                a
                ]._uniqueIds;
        for (let i = 0; i < group_uniqueIds.length; i++) {
          const sid = group_uniqueIds[i];
          for (let j = 0; j < conditionData.length; j++) {
            const item = conditionData[j];
            if (sid === item._uniqueId) {
              // 已组合的禁用勾选按钮和删除按钮
              if (group_uniqueIds.length > 1) {
                item.checkedDisabled = true;
              }
              newConditions.push(item);
              break;
            }
          }
        }
      }
      props.rowData[node!.dataId][activeNode.value!.isPre ? 'conditions' : 'effectConditions'] = newConditions;

      newGroup_uniqueIds = [];
      canGroup.value = false;
      treeGraph!.layout();
    };

    const discountChange = (e, type: string) => {

    };

    const resetConditionJsonData = (node) => {
      props.rowData[node.dataId].hasPrecondition = false;
      props.rowData[node.dataId].conditions = [];
      props.rowData[node.dataId].conditionsCombine.groups = [];
    };

    const resetRightsInfoJsonData = (node, type: 'FULL_SUB' | 'FULL_GWP' | 'DIRECT_DESCENT' | 'SECKILL') => {
      const paramsMap = {
        FULL_SUB: {
          directDescentOption: '', // 直降门槛规则
          reductionOption: fullSubRightsOperationOptions[0].value, //活动类型=满减时的优惠操作
          giftOption: '', //活动类型=满赠时的优惠操作
          reductionDiscount: fullSubTimesOptions[0].value, //操作类型为满减时的优惠类型
          giftDiscount: '' //操作为满赠时的优惠类型
        },
        FULL_GWP: {
          directDescentOption: '', // 直降门槛规则
          reductionOption: '', //活动类型=满减时的优惠操作
          giftOption: fullGwpRightsOperationOptions[0].value, //活动类型=满赠时的优惠操作
          reductionDiscount: '', //操作类型为满减时的优惠类型
          giftDiscount: fullGwpTimesOptions[0].value //操作为满赠时的优惠类型
        },
        DIRECT_DESCENT: {
          directDescentOption: directSubRuleOperationOptions[0].value, // 直降门槛规则
          reductionOption: '', //活动类型=满减时的优惠操作
          giftOption: '', //活动类型=满赠时的优惠操作
          reductionDiscount: '', //操作类型为满减时的优惠类型
          giftDiscount: '' //操作为满赠时的优惠类型
        },
        SECKILL: {
          directDescentOption: SECKILLRightsOperationOptions[0].value, // 秒杀规则
          reductionOption: '', //活动类型=满减时的优惠操作
          giftOption: '', //活动类型=满赠时的优惠操作
          reductionDiscount: '', //操作类型为满减时的优惠类型
          giftDiscount: '' //操作为满赠时的优惠类型
        }
      };

      props.rowData[node.dataId].equityInformationRule = {
        ...paramsMap[type],
        name: '',
        discountValue: 0, //优惠数值
        giftItemStr: '', // 满赠清单
        equityInfoItemStr: '', // 权益信息清单
        realPriceNotBenefits: true, // 实价产品不让利
        buyItNotBenefits: true, // 一口价产品不让利
        isAdvanced: false, // 是否高级配置
        advanceItemStr: '' // 高级配置清单
      };
    };

    // 收集政策下活动优先级
    const collectPriorities = (
        node: TNodeData,
        flag?: 'ADD' | 'DELETE' | 'UPDATE' | 'CHANGE_ONE_PRIORITY',
        poNode?: TNodeData
    ) => {
      let priorities: any = {}; // 优先级集合
      let policyNode: TNodeData; // 政策节点
      let allPriorities: string[] = []; // 所有活动叠加优先级
      let hasPrecondition = false; // 是否有前置条件
      let policyActivityNodes: TNodeData[] = []; // 政策下所有活动节点

      if (poNode) {
        policyNode = poNode;

        // 有前置条件
        if (poNode.children?.[0].type === CustomNodeType.CONDITIONS) {
          hasPrecondition = true;
          policyActivityNodes = policyNode.children![0].children;
        } else {
          policyActivityNodes = policyNode.children!;
        }
      } else {
        const parentNode = treeGraph!.getNeighbors(node.id)[0].getModel()! as TNodeData;
        // 有前置条件
        if (parentNode.type === CustomNodeType.CONDITIONS) {
          policyNode = treeGraph!.getNeighbors(parentNode.id)[0].getModel()! as TNodeData;
          hasPrecondition = true;
          policyActivityNodes = policyNode.children![0].children;
        }
        // 无前置条件
        else {
          policyNode = parentNode;
          policyActivityNodes = policyNode.children!;
        }
      }

      if (flag === 'DELETE') {
        // 过滤当前删除节点
        if (hasPrecondition) {
          policyNode.children![0].children = policyNode.children![0].children?.filter((i) => i.id !== node.id);
        } else {
          policyNode.children = policyNode.children?.filter((i) => i.id !== node.id);
        }
        // 删除所有活动已经使用的当前活动的优先级
        policyActivityNodes.forEach((i) => {
          const selecedPriorities = (props.rowData[i.dataId] as any).promotionSuperpositionPriority?.split('#') ?? [];
          selecedPriorities.forEach((j, index) => {
            if (j === props.rowData[node.dataId].priority.toString()) {
              selecedPriorities.splice(index, 1);
              (props.rowData[i.dataId] as any).promotionSuperpositionPriority = selecedPriorities.join('#');
            }
          });
        });
      }

      // 收集当前政策所有活动优先级
      policyActivityNodes.forEach((i) => {
        const p = (props.rowData[i.dataId] as TNodeData).priority?.toString();
        if (typeof p === 'undefined' || p === '') {
          delete priorities[i.id];
        } else {
          priorities[i.id] = {
            id: i.id + '',
            dataId: i.dataId,
            value: p,
            // FIXME: priority不能为0
            isMain: !!(props.rowData[i.dataId] as any).promotionSuperpositionPriority?.split('#')?.filter((i) => i)
                ?.length
          };
        }
        allPriorities = allPriorities.concat(
            ((props.rowData[i.dataId] as any).promotionSuperpositionPriority || '').split('#')
        );
      });

      // 标记从节点
      const setSubFlag = () => {
        policyActivityNodes.forEach((i) => {
          // 标记从节点
          const p = (props.rowData[i.dataId] as TNodeData).priority!.toString();
          if (allPriorities.includes(p) && priorities[i.id]) {
            priorities[i.id].isSub = true;
          }

          (props.rowData[i.dataId] as any).activityAllPriority = priorities;
          // 过滤空数据
          (props.rowData[i.dataId] as any).promotionSuperpositionPriority =
              (props.rowData[i.dataId] as any).promotionSuperpositionPriority
                  ?.split('#')
                  ?.filter((i) => i)
                  ?.join('#') ?? '';
        });
      };

      // 活动优先级更新，相同优先级数值更新或者清空
      if (flag === 'CHANGE_ONE_PRIORITY' && props.rowData[node.dataId].priority !== '') {
        // 检测修改之前的优先级是否有使用到
        const used =
            props.rowData[node.dataId].prevPriority !== '' &&
            allPriorities.includes(props.rowData[node.dataId].prevPriority.toString());
        if (used) {
          // 替换当前政策下所有使用到该活动的选项值
          const setUsedPrioritiesValue = (value: string) => {
            policyActivityNodes.forEach((i) => {
              const selecedPriorities =
                  (props.rowData[i.dataId] as any).promotionSuperpositionPriority?.split('#') ?? [];
              selecedPriorities.forEach((j, index) => {
                if (j === props.rowData[node.dataId].prevPriority.toString()) {
                  selecedPriorities[index] = value;
                  (props.rowData[i.dataId] as any).promotionSuperpositionPriority = selecedPriorities.join('#');
                }
              });
            });
          };
          Modal.confirm({
            getContainer: () => document.getElementById('mountNode')!,
            class: 'oio-modal',
            title: '检测到当前活动已与其他活动叠加，请谨慎选择需要的操作',
            icon: createVNode(ExclamationCircleOutlined),
            cancelText: '清空',
            okText: '替换',
            onOk() {
              // 替换当前政策下所有使用到该活动的选项为最新值
              setUsedPrioritiesValue(props.rowData[node.dataId].priority.toString());
              setSubFlag();
              treeGraph!.layout();
            },
            onCancel() {
              // 清空当前政策下所有使用到该活动的选项值
              setUsedPrioritiesValue('');
              setSubFlag();
              treeGraph!.layout();
            }
          });
        } else {
          setSubFlag();
        }
      } else {
        setSubFlag();
      }
    };

    // 前置条件开关
    // @ts-ignore
    window.onActivityToggleSwitch = (id) => {
      const node = treeGraph!.findDataById(id)! as TNodeData;
      activeNode.value = node;

      // 根节点
      if (node.type === CustomNodeType.PLAN) {
        // 开启前置条件
        if (!node.actionBar.switchAction.open) {
          // 无子节点
          if (!node.children?.length) {
            node.children = [
              createConditionData({isPre: true, jsonData: props.rowData[node.dataId], rowData: props.rowData})
            ];
          }
          // 有子节点
          else {
            const conditionNode = createConditionData({
              isPre: true,
              jsonData: props.rowData[node.dataId],
              rowData: props.rowData
            });
            conditionNode.children = node.children;
            node.children = [conditionNode];
          }
          node.actionBar.switchAction.open = !node.actionBar.switchAction.open;
          props.rowData[node.dataId].hasPrecondition = true;

          updateTree();
        }
        // 关闭前置条件
        else {
          Modal.confirm({
            getContainer: () => document.getElementById('mountNode')!,
            class: 'oio-modal',
            title: '关闭后将清空前置条件内容，确认关闭吗?',
            icon: createVNode(ExclamationCircleOutlined),
            onOk() {
              // // 取消勾选状态
              // props.rowData[node.dataId].conditions.forEach((i) => {
              //   if (!i.checkedDisabled) {
              //     i.checked = false;
              //   }
              // });
              if (activeNode.value!.id === node.id) {
                newGroup_uniqueIds = [];
                canGroup.value = false;
              }

              node.children = node.children![0].children!;

              resetConditionJsonData(node);
              node.actionBar.switchAction.open = !node.actionBar.switchAction.open;
              props.rowData[node.dataId].hasPrecondition = false;

              updateTree();
            }
          });
        }
      }
      // 促销政策节点
      else if (node.type === CustomNodeType.POLICY) {
        // 开启前置条件
        if (!node.actionBar.switchAction.open) {
          // 无子节点
          if (!node.children?.length) {
            node.children = [
              createConditionData({isPre: true, jsonData: props.rowData[node.dataId], rowData: props.rowData})
            ];
          }
          // 有子节点
          else {
            const conditionNode = createConditionData({
              isPre: true,
              jsonData: props.rowData[node.dataId],
              rowData: props.rowData
            });
            conditionNode.children = node.children;
            node.children = [conditionNode];
          }
          node.actionBar.switchAction.open = !node.actionBar.switchAction.open;
          props.rowData[node.dataId].hasPrecondition = true;

          updateTree();
        }
        // 关闭前置条件
        else {
          Modal.confirm({
            getContainer: () => document.getElementById('mountNode')!,
            class: 'oio-modal',
            title: '关闭后将清空前置条件内容，确认关闭吗?',
            icon: createVNode(ExclamationCircleOutlined),
            onOk() {
              // // 取消勾选状态
              // props.rowData[node.dataId].conditions.forEach((i) => {
              //   if (!i.checkedDisabled) {
              //     i.checked = false;
              //   }
              // });
              if (activeNode.value!.id === node.id) {
                newGroup_uniqueIds = [];
                canGroup.value = false;
              }
              node.children = node.children![0].children!;

              resetConditionJsonData(node);
              node.actionBar.switchAction.open = !node.actionBar.switchAction.open;
              props.rowData[node.dataId].hasPrecondition = false;

              updateTree();
            }
          });
        }
      }
      // 活动类型节点
      else if (node.type === CustomNodeType.ACTIVITY_TYPE) {
        // 开启前置条件
        if (!node.actionBar.switchAction.open) {
          const conditionNode = createConditionData({
            isPre: true,
            jsonData: props.rowData[node.dataId],
            rowData: props.rowData
          });
          conditionNode.children = node.children!;
          node.children = [conditionNode];
          node.actionBar.switchAction.open = !node.actionBar.switchAction.open;
          props.rowData[node.dataId].hasPrecondition = true;

          updateTree();
        }
        // 关闭前置条件
        else {
          Modal.confirm({
            getContainer: () => document.getElementById('mountNode')!,
            class: 'oio-modal',
            title: '关闭后将清空前置条件内容，确认关闭吗?',
            icon: createVNode(ExclamationCircleOutlined),
            onOk() {
              // // 取消勾选状态
              // props.rowData[node.dataId].conditions.forEach((i) => {
              //   if (!i.checkedDisabled) {
              //     i.checked = false;
              //   }
              // });
              if (activeNode.value!.id === node.id) {
                newGroup_uniqueIds = [];
                canGroup.value = false;
              }

              node.children = node.children![0].children!;

              resetConditionJsonData(node);
              node.actionBar.switchAction.open = !node.actionBar.switchAction.open;
              props.rowData[node.dataId].hasPrecondition = false;

              updateTree();
            }
          });
        }
      }
      treeGraph!.layout();
    };

    // ActionBar关联商品清单
    // @ts-ignore
    window.onActivityLinkProducts = (id) => {
      const node = treeGraph!.findDataById(id)! as TNodeData;
      activeNode.value = node;

      // 促销政策关联商品清单
      if (node.type === CustomNodeType.POLICY) {
        selectedLinkName.value = props.rowData[node.dataId].promotionItemStr;
      }
      // 权益信息关联商品清单
      else if (node.type === CustomNodeType.RIGHTS_INFO) {
        selectedLinkName.value = props.rowData[node.dataId].equityInformationRule.equityInfoItemStr;
      }

      showLinkModal.value = true;
      treeGraph!.layout();
    };

    // ActionBar添加
    // @ts-ignore
    window.onActivityAdd = (id) => {
      const node = treeGraph!.findDataById(id)! as TNodeData;
      const rootNode = treeGraph!.getNodes()[0].getModel();
      activeNode.value = node;

      // 根节点
      if (node.type === CustomNodeType.PLAN) {
        // 开启前置条件
        if (node.actionBar.switchAction.open) {
          node.children![0].children!.push(createPolicyData({parentId: rootNode.id, rowData: props.rowData}));
        }
        // 未开启前置条件
        else {
          node.children!.push(createPolicyData({parentId: rootNode.id, rowData: props.rowData}));
        }
      }
          // 促销政策
      // FIXME: 一个政策目前需求下，限制最多添加5个活动
      else if (node.type === CustomNodeType.POLICY) {
        const activeTypeNode = createActivityTypeData({parentId: id, rowData: props.rowData});
        let ruleNode;
        let rightsInfoNode = createRightsInfoData({
          jsonData: props.rowData[activeTypeNode.dataId],
          rowData: props.rowData
        });

        let activityChildren: any[] = [];
        if (node.children?.[0]?.type === CustomNodeType.CONDITIONS) {
          activityChildren = node.children![0].children!;
        } else {
          activityChildren = node.children!;
        }
        if (activityChildren.length === 0) {
          ruleNode = createConditionData({
            isPre: false,
            jsonData: props.rowData[activeTypeNode.dataId],
            rowData: props.rowData
          });
          // 活动类型为”满减“、权益类型为”减金额“时，隐藏关联按钮
          rightsInfoNode.actionBar.linkAction = false;
          rightsInfoNode.actionBar.settingAction = true;
        } else {
          ruleNode = createConditionData({
            isPre: false,
            jsonData: props.rowData[activeTypeNode.dataId],
            rowData: props.rowData
          });

          // 活动类型为”满减“、权益类型为”减金额“时，隐藏关联按钮
          rightsInfoNode.actionBar.linkAction = false;
          rightsInfoNode.actionBar.settingAction = true;

          // 活动优先级自动升序
          props.rowData[activeTypeNode.dataId].priority =
              Math.max(...activityChildren.map((i) => Number(props.rowData[i.dataId].priority))) + 1;
        }

        rightsInfoNode.policyId = id;

        ruleNode.children = [rightsInfoNode];
        activeTypeNode.children = [ruleNode];

        // 开启前置条件
        if (node.actionBar.switchAction.open) {
          node.children![0].children!.push(activeTypeNode);
        }
        // 未开启前置条件
        else {
          node.children!.push(activeTypeNode);
        }

        collectPriorities(activeTypeNode, 'ADD', node);
      }

      treeGraph!.layout();
    };

    // ActionBar设置
    // @ts-ignore
    window.onActivitySettings = (id) => {
      const node = treeGraph!.findDataById(id)! as TNodeData;
      const jsonData = props.rowData[node.dataId];
      activeNode.value = node;

      // 促销政策配置
      if (node.type === CustomNodeType.POLICY) {
        showPolicyModal.value = true;
        // 初始化记账时间规则
        if (!jsonData.policyInfo.accountTimeRule) {
          jsonData.policyInfo.accountTimeRule = props._formData.accountTimeRule || '';
        }
        // // 初始化指定记账时间
        // if (!jsonData.policyInfo.accountDate) {
        //   jsonData.policyInfo.accountDate = props._formData.accountDate || '';
        // }
      }
      // 权益信息配置
      else if ([CustomNodeType.RIGHTS_INFO, CustomNodeType.SIMPLE_RIGHTS_INFO].includes(node.type)) {
        selectedLinkName.value = props.rowData[node.dataId].equityInformationRule.advanceItemStr;
        showRightsSettingModal.value = true;
      }
    };

    // ActionBar删除
    // @ts-ignore
    window.onActivityDelete = (id) => {
      const node = treeGraph!.findDataById(id)! as TNodeData;
      activeNode.value = node;

      Modal.confirm({
        getContainer: () => document.getElementById('mountNode')!,
        class: 'oio-modal',
        title: '删除后不可恢复，确认删除吗?',
        icon: createVNode(ExclamationCircleOutlined),
        onOk() {
          // 根节点
          if (node.type === CustomNodeType.PLAN) {
            // 开启前置条件
            if (node.actionBar.switchAction.open) {
              node.children![0].children = [];
            }
            // 未开启前置条件
            else {
              node.children = [];
            }
          }
          // 促销政策
          else if (node.type === CustomNodeType.POLICY) {
            const parentNode = treeGraph!.getNeighbors(id)[0].getModel();
            const index = (parentNode.children as any[])!.findIndex((i) => i.id === id);
            if (index != -1) {
              (parentNode.children as any[]).splice(index, 1);
            }
          }
          // 活动类型
          else if (node.type === CustomNodeType.ACTIVITY_TYPE) {
            collectPriorities(node, 'DELETE');
            const parentNode = treeGraph!.getNeighbors(id)[0].getModel();
            const index = (parentNode.children as any[])!.findIndex((i) => i.id === id);
            if (index != -1) {
              (parentNode.children as any[]).splice(index, 1);
            }
          }

          treeGraph!.layout();
        }
      });
    };

    // 前置条件关联商品清单打开弹窗
    // @ts-ignore
    window.onActivityRuleLinkProducts = (id, index) => {
      const node = treeGraph!.findDataById(id)! as TNodeData;
      activeNode.value = node;
      selectedLinkName.value = props.rowData[node.dataId].conditions[index].promotionItemStr;

      showLinkModal.value = true;
      activeConditionIndex = index;
    };

    // 添加规则
    // @ts-ignore
    window.onActivityAddRule = (id) => {
      const node = treeGraph!.findDataById(id)! as TNodeData;
      activeNode.value = node;
      const newConditionsRow = createConditionRowJsonData(node.isPre);
      props.rowData[node.dataId][node.isPre ? 'conditions' : 'effectConditions'].push(newConditionsRow);
      props.rowData[node.dataId][node.isPre ? 'conditionsCombine' : 'effectConditionsCombine'].groups.push({
        _uniqueIds: [newConditionsRow._uniqueId], //条件组
        type: 'and' //一组的逻辑运算符
      });

      node.y! -= conditionRowHeight / 2;
      node.size![1] += conditionRowHeight;
      node.anchorPoints = [
        [0, (node.size![1] - actionBarHeight) / 2 / node.size![1]],
        [1, (node.size![1] - actionBarHeight) / 2 / node.size![1]]
      ];

      treeGraph!.layout();
    };

    // 删除规则
    // @ts-ignore
    window.onActivityDeleteRule = (id, index) => {
      const node = treeGraph!.findDataById(id)! as TNodeData;
      activeNode.value = node;
      const conditionData = props.rowData[node.dataId][node.isPre ? 'conditions' : 'effectConditions'];
      const combineData = props.rowData[node.dataId][node.isPre ? 'conditionsCombine' : 'effectConditionsCombine'];

      if (conditionData[index].checkedDisabled) return;
      if (conditionData.length === 1) {
        message.warning('至少保留一条规则');
        return;
      }

      Modal.confirm({
        getContainer: () => document.getElementById('mountNode')!,
        class: 'oio-modal',
        title: '删除后不可恢复，确认删除吗?',
        icon: createVNode(ExclamationCircleOutlined),
        onOk() {
          const uid = conditionData[index]._uniqueId;
          combineData.groups.forEach((i, index) => {
            if (i._uniqueIds[0] === uid) {
              combineData.groups.splice(index, 1);
            }
          });

          const delUniqId = conditionData[index]._uniqueId;
          conditionData.splice(index, 1);

          node.y! += conditionRowHeight / 2;
          node.size![1] -= conditionRowHeight;
          node.anchorPoints = [
            [0, (node.size![1] - actionBarHeight) / 2 / node.size![1]],
            [1, (node.size![1] - actionBarHeight) / 2 / node.size![1]]
          ];

          // 满赠时，如果不存在满款数条件，则放开权益信息第一列禁用的选项
          if (
              !node.isPre &&
              props.rowData[node.dataId].optionType === 'FULL_GWP' &&
              props.rowData[node.dataId].effectConditions.every((i) => i.optionType !== 'FULL_PAYMENT')
          ) {
            node.children![0].col1DisabledOptions = [];
          }

          // 检查是否可组合
          const delIndex = newGroup_uniqueIds.findIndex((i) => i === delUniqId);
          newGroup_uniqueIds.splice(delIndex, 1);
          if (newGroup_uniqueIds.length > 1) {
            canGroup.value = true;
          } else {
            canGroup.value = false;
          }

          treeGraph!.layout();
        }
      });
    };

    // 勾选/取消勾选规则
    // @ts-ignore
    window.onActivityCheckRule = (id, index) => {
      const node = treeGraph!.findDataById(id)! as TNodeData;
      const conditionData = props.rowData[node.dataId][node.isPre ? 'conditions' : 'effectConditions'];
      const _uids = conditionData.map((a) => a._uniqueId);
      activeNode.value = node;

      if (conditionData[index].checkedDisabled) return;

      // 已勾选的项需在同一个节点上
      if (!newGroup_uniqueIds.every((i) => _uids.includes(i))) {
        message.warning('请优先处理【已勾选规则,但未进行组合】的节点');

        return;
      }

      props.rowData[node.dataId][node.isPre ? 'conditions' : 'effectConditions'][index].checked =
          !props.rowData[node.dataId][node.isPre ? 'conditions' : 'effectConditions'][index].checked;

      // 判断是否可进行组合
      // 当前节点，已勾选的所有行的_uniqueId未在已组合的_uniqueId里的数量>1，则可组合

      // 选中
      if (props.rowData[node.dataId][node.isPre ? 'conditions' : 'effectConditions'][index].checked) {
        const groups = props.rowData[node.dataId][node.isPre ? 'conditionsCombine' : 'effectConditionsCombine'].groups;
        const groupedGroups = groups.filter((i) => i._uniqueIds.length > 1); // 已组合的组
        conditionData.forEach((i) => {
          if (
              i.checked &&
              groupedGroups.every((j) => !j._uniqueIds.includes(i._uniqueId)) &&
              !newGroup_uniqueIds.includes(i._uniqueId)
          ) {
            newGroup_uniqueIds.push(i._uniqueId);
          }
        });
      }
      // 取消选中
      else {
        const delIndex = newGroup_uniqueIds.findIndex((i) => i === conditionData[index]._uniqueId);
        newGroup_uniqueIds.splice(delIndex, 1);
      }
      if (newGroup_uniqueIds.length > 1) {
        canGroup.value = true;
      } else {
        canGroup.value = false;
      }

      treeGraph!.layout();
    };

    // 组合改变(and/or/cancel)
    // @ts-ignore
    window.onNodeGrouptypeChange = (id, e, groupIndex, isAll) => {
      const node = treeGraph!.findDataById(id)! as TNodeData;
      activeNode.value = node;
      // 且/或 切换
      if (e.value !== 'cancel') {
        if (isAll) {
          props.rowData[node.dataId][node.isPre ? 'conditionsCombine' : 'effectConditionsCombine'].type = e.value;
        } else {
          props.rowData[node.dataId][node.isPre ? 'conditionsCombine' : 'effectConditionsCombine'].groups[
              groupIndex
              ].type = e.value;
        }
      }
      // 取消组
      else {
        // 已勾选的项需在同一个节点上
        if (newGroup_uniqueIds.length > 0) {
          message.warning('请优先处理【已勾选规则,但未进行组合】的节点');
          treeGraph!.layout();

          return;
        }

        const conditionData = props.rowData[node.dataId][node.isPre ? 'conditions' : 'effectConditions'];
        const curGroup =
            props.rowData[node.dataId][node.isPre ? 'conditionsCombine' : 'effectConditionsCombine'].groups[groupIndex];
        // 启用勾选、删除按钮
        props.rowData[node.dataId][node.isPre ? 'conditions' : 'effectConditions'].forEach((i) => {
          if (curGroup._uniqueIds.includes(i._uniqueId)) {
            i.checkedDisabled = false;
          }
        });
        // 分解为单行组
        const singleGroups = curGroup._uniqueIds.map((i) => ({
          _uniqueIds: [i],
          type: 'and'
        }));
        props.rowData[node.dataId][node.isPre ? 'conditionsCombine' : 'effectConditionsCombine'].groups.splice(
            groupIndex,
            1,
            ...singleGroups
        );
        // 取消勾选状态
        props.rowData[node.dataId][node.isPre ? 'conditions' : 'effectConditions'].forEach((i) => {
          if (curGroup._uniqueIds.includes(i._uniqueId)) {
            i.checked = false;
          }
        });
      }
      treeGraph!.layout();
    };

    // 条件-操作类型修改
    // @ts-ignore
    window.onConditionOperationChange = (id, e, index) => {
      const node = treeGraph!.findDataById(id)! as TNodeData;
      const parentNode = treeGraph!.getNeighbors(id)[0].getModel() as TNodeData;
      const rowData = props.rowData[node.dataId][node.isPre ? 'conditions' : 'effectConditions'][index];
      activeNode.value = node;

      rowData.optionType = e.value;
      // 重置值
      rowData.itemUnit = '';
      rowData.moneyUnit = '';
      rowData.orderUnit = '';
      rowData.packageUnit = '';
      rowData.promotionItemStr = '';

      // 当前是门槛规则节点
      if (!node.isPre) {
        let activityNode;
        // 前置节点是前置条件
        if (parentNode.type === CustomNodeType.CONDITIONS) {
          activityNode = treeGraph!.getNeighbors(parentNode.id!)[0].getModel();
        }
        // 前置节点是活动类型
        else {
          activityNode = parentNode;
        }

        // 权益信息节点
        node.children![0].col1DisabledOptions = [];

        const hasFullItemTypeCondition = props.rowData[node.dataId].effectConditions.some(
            (i) => i.optionType === 'FULL_PAYMENT'
        );
        // 活动类型为满赠，且门槛规则存在满款数时，禁用权益规则第一列部分选项，且重置选择项为第一个选项
        if (props.rowData[activityNode.dataId].optionType === 'FULL_GWP' && hasFullItemTypeCondition) {
          node.children![0].col1DisabledOptions = [
            'ITEM_FULL_A_TO_A',
            'ITEM_FULL_A_TO_B',
            'ARTICLE_FULL_A_TO_A',
            'ARTICLE_FULL_A_TO_B'
          ];
          props.rowData[node.dataId].equityInformationRule.giftOption = fullGwpRightsOperationOptions[0].value;
          props.rowData[node.dataId].equityInformationRule.giftDiscount = fullGwpTimesOptions[0].value;
        }
      }

      // 设置值

      // 起订量
      rowData.orderUnit = startPkgOptions[0].value;
      // 满金额
      if (e.value === 'FULL_AMOUNT') {
        rowData.moneyUnit = fullMoneyOptions[0].value;
      }
      // 满款数
      else if (e.value === 'FULL_PAYMENT') {
        rowData.itemUnit = fullTypeOptions[0].value;
      }
      // 满数量
      else if (e.value === 'FULL_QUANTITY') {
        rowData.packageUnit = fullPkgOptions[0].value;
      }

      treeGraph!.layout();
    };

    // 条件-操作类型数值修改
    // @ts-ignore
    window.onConditionOperationValueInput = (id, e, index) => {
      const node = treeGraph!.findDataById(id)! as TNodeData;
      let ele = document.querySelector(
          `#input_${props.rowData[node.dataId][node.isPre ? 'conditions' : 'effectConditions'][index]._uniqueId}`
      ) as HTMLInputElement;
      const parts = e.value.split('.');
      activeNode.value = node;

      if (parts.length > 2) {
        // 有多个小数点，清除额外的小数点
        e.value = parts[0] + '.' + parts.slice(1).join('');
      }

      selectionStart = ele.selectionStart!;
      selectionEnd = ele.selectionEnd!;
      props.rowData[node.dataId][node.isPre ? 'conditions' : 'effectConditions'][index].optionValue = e.value.replace(
          /[^\d.]/g,
          ''
      );

      treeGraph!.layout();

      ele = document.querySelector(
          `#input_${props.rowData[node.dataId][node.isPre ? 'conditions' : 'effectConditions'][index]._uniqueId}`
      ) as HTMLInputElement;
      ele.focus();
      ele.setSelectionRange(selectionStart, selectionEnd);
    };

    // 条件-起订包装单位修改
    // @ts-ignore
    window.onStartOrderUnitChange = (id, e, index) => {
      const node = treeGraph!.findDataById(id)! as TNodeData;
      activeNode.value = node;

      props.rowData[node.dataId][node.isPre ? 'conditions' : 'effectConditions'][index].orderUnit = e.value;

      treeGraph!.layout();
    };

    // 条件-满数值修改
    // @ts-ignore
    window.onFullUnitInput = (id, e, index) => {
      const node = treeGraph!.findDataById(id)! as TNodeData;
      activeNode.value = node;

      const parts = e.value.split('.');
      if (parts.length > 2) {
        // 有多个小数点，清除额外的小数点
        e.value = parts[0] + '.' + parts.slice(1).join('');
      }
      let ele = document.querySelector(
          `#full-unit_${props.rowData[node.dataId][node.isPre ? 'conditions' : 'effectConditions'][index]._uniqueId}`
      ) as HTMLInputElement;

      selectionStart = ele.selectionStart!;
      selectionEnd = ele.selectionEnd!;
      props.rowData[node.dataId][node.isPre ? 'conditions' : 'effectConditions'][index].fullNumber = e.value.replace(
          /[^\d.]/g,
          ''
      );
      treeGraph!.layout();

      ele = document.querySelector(
          `#full-unit_${props.rowData[node.dataId][node.isPre ? 'conditions' : 'effectConditions'][index]._uniqueId}`
      ) as HTMLInputElement;
      ele.focus(); // 聚焦到number input元素
      ele.setSelectionRange(selectionStart, selectionEnd);
    };

    // 条件-活动提示文案
    // @ts-ignore
    window.onActivityDescBlur = (id, e) => {
      const node = treeGraph!.findDataById(id)! as TNodeData;
      const jsonData = props.rowData[node.dataId];
      activeNode.value = node;

      if (node.isPre) {
        jsonData.conditionDesc = e.value;
      } else {
        jsonData.effectConditionDesc = e.value;
      }

      treeGraph!.layout();
    };

    // 条件-满单位修改
    // @ts-ignore
    window.onFullUnitChange = (id, e, index) => {
      const node = treeGraph!.findDataById(id)! as TNodeData;
      activeNode.value = node;

      const optionType = props.rowData[node.dataId][node.isPre ? 'conditions' : 'effectConditions'][index].optionType;
      const k = fullOptionsValueMap[optionType];
      props.rowData[node.dataId][node.isPre ? 'conditions' : 'effectConditions'][index][k] = e.value;

      treeGraph!.layout();
    };

    const clearOtherActivityUsedCurrentPriority = (currentNode: TNodeData) => {
      const parentNode = treeGraph!.getNeighbors(currentNode.id!)[0].getModel() as TNodeData;
      const currentPriority = props.rowData[currentNode.dataId].priority.toString();
      let policyNode;

      // 有前置条件
      if (parentNode.type === CustomNodeType.CONDITIONS) {
        policyNode = treeGraph!.getNeighbors(parentNode.id!)[0].getModel() as TNodeData;
      }
      // 无前置条件
      else {
        policyNode = parentNode;
      }

      const otherActivityNodesData = policyNode.children
          .filter((i) => i.id !== currentNode.id)
          .map((i) => props.rowData[i.dataId]);

      otherActivityNodesData.forEach((i) => {
        const selectedPriorityArr = i.promotionSuperpositionPriority?.split('#');
        if (selectedPriorityArr) {
          if (selectedPriorityArr.includes(currentPriority)) {
            i.promotionSuperpositionPriority = selectedPriorityArr.filter((j) => j !== currentPriority).join('#');
          }
        }

      });
    };

    // 活动类型修改
    // @ts-ignore
    window.onActivityTypeChange = (id, e) => {
      const node = treeGraph!.findDataById(id)! as TNodeData;
      const jsonData = props.rowData[node.dataId];
      activeNode.value = node;
      const prevOptionType = jsonData.optionType;
      // 直降
      if (e.value === 'DIRECT_DESCENT') {
        const rightsInfoNode = createRightsInfoData({jsonData, rowData: props.rowData});
        const ruleNode = createSimpleConditionData({jsonData, rowData: props.rowData});
        // 隐藏权益信息关联按钮
        rightsInfoNode.actionBar.linkAction = false;

        ruleNode.children = [rightsInfoNode];

        // 直降没有前置条件
        node.children![0] = ruleNode;
        jsonData.hasPrecondition = false;

        // 隐藏前置条件开关
        node.actionBar.switchAction.show = false;
        node.actionBar.switchAction.open = false;

        // 清空满减/满赠门槛规则、组合、表达式、权益信息
        jsonData.effectConditions = [];
        jsonData.effectLogicalExpression = '';
        jsonData.effectConditionsCombine = {
          type: 'and',
          groups: []
        };

        // 重置当前节点叠加
        jsonData.promotionSuperpositionPriority = '';
        // 重置其他节点叠加了当前节点优先级的活动
        clearOtherActivityUsedCurrentPriority(node);

      }// 满减、满赠、秒杀
      else {
        const parentNode = treeGraph!.getNeighbors(id)[0].getModel();
        const rightsInfoNode = createRightsInfoData({jsonData, rowData: props.rowData});
        const ruleNode = createConditionData({
          isPre: false,
          isEdit: !!jsonData.effectConditions.length,
          jsonData,
          rowData: props.rowData
        });
        if (e.value === 'FULL_SUB' || e.value === 'SECKILL') {
          rightsInfoNode.actionBar.settingAction = true;
          rightsInfoNode.actionBar.linkAction = false;
        }

        ruleNode.children = [rightsInfoNode];

        // 父节点为前置条件
        if (parentNode.type === CustomNodeType.CONDITIONS) {
          rightsInfoNode.policyId = treeGraph!.getNeighbors(parentNode.id!)[0].getModel().id!;
          (treeGraph!.getNeighbors(parentNode.id!)[0].getModel() as any).actionBar.linkAction = true;
        }
        // 父节点为促销政策
        else {
          rightsInfoNode.policyId = parentNode.id!;
          (parentNode.actionBar as any).linkAction = true;
        }

        // 开启前置条件
        if (jsonData.hasPrecondition) {
          node.children![0].children![0] = ruleNode;
        }
        // 未开启前置条件
        else {
          node.children![0] = ruleNode;
        }

        // 显示前置条件开关
        node.actionBar.switchAction.show = true;

        // 清空直降门槛规则
        jsonData.equityInformationRule.directDescentOption = '';

        // 重置叠加
        if (prevOptionType === 'DIRECT_DESCENT') {
          jsonData.promotionSuperpositionPriority = '';
        }
        // 满赠切至满减
        else if (prevOptionType === 'FULL_GWP') {
          // 重置其他节点叠加了当前节点优先级的活动
          clearOtherActivityUsedCurrentPriority(node);
        }
        const hasFullItemTypeCondition = props.rowData[node.dataId].effectConditions.some(
            (i) => i.optionType === 'FULL_PAYMENT'
        );
        // 活动类型为满赠，且门槛规则存在满款数时，禁用权益规则第一列部分选项
        if (e.value === 'FULL_GWP' && hasFullItemTypeCondition) {
          rightsInfoNode.col1DisabledOptions = [
            'ITEM_FULL_A_TO_A',
            'ITEM_FULL_A_TO_B',
            'ARTICLE_FULL_A_TO_A',
            'ARTICLE_FULL_A_TO_B'
          ];
        } else {
          rightsInfoNode.col1DisabledOptions = [];
        }
      }

      resetRightsInfoJsonData(node, e.value);

      // 开启前置条件
      if (jsonData.hasPrecondition) {
        node.children![0].children![0].children![0].activityType = e.value;
      }
      // 未开启前置条件
      else {
        node.children![0].children![0].activityType = e.value;
      }

      jsonData.optionType = e.value;
      collectPriorities(node, 'UPDATE');

      treeGraph!.layout();
    };

    // 活动优先级修改
    // @ts-ignore
    window.onActivityPriorityInput = (id, e) => {
      const node = treeGraph!.findDataById(id)! as TNodeData;
      let ele = document.querySelector(`#input_${id}`) as HTMLInputElement;
      activeNode.value = node;

      selectionStart = ele.selectionStart!;
      selectionEnd = ele.selectionEnd!;
      props.rowData[node.dataId].prevPriority = props.rowData[node.dataId].priority; // 记录上一次的优先级
      props.rowData[node.dataId].priority = e.value.replace(/[^\d]/g, '');
      // @ts-ignore
      window.isActivityPrioritySystemBlur = true;
      treeGraph!.layout();

      ele = document.querySelector(`#input_${id}`) as HTMLInputElement;
      ele.focus(); // 聚焦到number input元素
      ele.setSelectionRange(selectionStart, selectionEnd);
      // @ts-ignore
      window.isActivityPrioritySystemBlur = false;
    };

    // 活动优先级不能有相同数值
    // @ts-ignore
    window.onActivityPriorityBlur = (id, e) => {
      const node = treeGraph!.findDataById(id)! as TNodeData;
      const parentNode = cloneDeep(treeGraph!.getNeighbors(id)[0].getModel());
      const index = (parentNode.children as any[])!.findIndex((i) => i.id == id);
      if (index != -1) {
        (parentNode.children as any[]).splice(index, 1);
      }
      const hasSamePriority = (parentNode.children as any[]).some(
          (i) => props.rowData[i.dataId].priority !== '' && props.rowData[i.dataId].priority == e.value
      );
      // @ts-ignore
      if (!window.isActivityPrioritySystemBlur) {
        if (hasSamePriority) {
          Modal.confirm({
            getContainer: () => document.getElementById('mountNode')!,
            class: 'oio-modal',
            title: '当前活动优先级与已有活动优先级重复，请重新设置',
            icon: createVNode(ExclamationCircleOutlined),
            onOk() {
            }
          });
          props.rowData[node.dataId].priority = props.rowData[node.dataId].prevPriority;
          treeGraph!.layout();
        } else if (props.rowData[node.dataId].priority != props.rowData[node.dataId].prevPriority) {
          collectPriorities(node, 'CHANGE_ONE_PRIORITY');
          treeGraph!.layout();
        }
      }
    };

    // 叠加活动优先级
    // @ts-ignore
    window.onActivityTypeDiejiaChange = (id, e, index) => {
      const node = treeGraph!.findDataById(id)! as TNodeData;
      activeNode.value = node;
      index = Number(index);

      if (!props.rowData[node.dataId].promotionSuperpositionPriority) {
        props.rowData[node.dataId].promotionSuperpositionPriority = e.value.toString();
      } else {
        const priorityArr = props.rowData[node.dataId].promotionSuperpositionPriority.split('#');
        // 禁止重复叠加同一优先级
        if (
            e.value !== '' &&
            props.rowData[node.dataId].promotionSuperpositionPriority.split('#').includes(e.value.toString())
        ) {
          Modal.confirm({
            getContainer: () => document.getElementById('mountNode')!,
            class: 'oio-modal',
            title: `无法重复叠加活动「${e.value}」，请重新设置`,
            icon: createVNode(ExclamationCircleOutlined),
            onOk() {
            }
          });
        } else {
          if (index < priorityArr.length) {
            priorityArr[index] = e.value.toString();
          } else {
            priorityArr.push(e.value.toString());
          }
          props.rowData[node.dataId].promotionSuperpositionPriority = priorityArr.join('#');
        }
      }

      collectPriorities(node);
      treeGraph!.layout();
    };

    // 直降门槛规则修改
    // @ts-ignore
    window.onSimpleConditionChange = (id, e) => {
      const node = treeGraph!.findDataById(id)! as TNodeData;
      activeNode.value = node;
      props.rowData[node.dataId].equityInformationRule.directDescentOption = e.value;

      treeGraph!.layout();
    };

    // 权益信息第一列修改
    // @ts-ignore
    window.onRightsInfoCol1Change = (id, e) => {
      const node = treeGraph!.findDataById(id)! as TNodeData;
      activeNode.value = node;

      props.rowData[node.dataId].equityInformationRule[rightsOperationsOptionsKeyMap[node.activityType]] = e.value;

      // 活动类型为满赠，且权益类型为"料号满A赠A"或"货号满A赠A"
      if (node.activityType === 'FULL_GWP') {
        if (['ITEM_FULL_A_TO_A', 'ARTICLE_FULL_A_TO_A'].includes(e.value)) {
          // 隐藏关联商品清单按钮
          node.actionBar.linkAction = false;
          // 权益关联商品清单=促销政策关联商品清单
          const policyNode = treeGraph!.findDataById(node.policyId);
          props.rowData[node.dataId].equityInformationRule.equityInfoItemStr = (
              props.rowData[policyNode!.dataId as string] as any
          ).promotionItemStr;
        } else {
          // 显示关联商品清单按钮
          node.actionBar.linkAction = true;
          // 清空权益关联商品清单
          props.rowData[node.dataId].equityInformationRule.equityInfoItemStr = '';
        }
      }

      // 活动类型为满减
      if (node.activityType === 'FULL_SUB') {
        // 权益类型为“折扣率”
        if (e.value === 'DISCOUNT_RATE') {
          // 显示设置按钮
          node.actionBar.settingAction = true;
          // 隐藏关联按钮
          node.actionBar.linkAction = false;
        } else {
          // 权益类型为“减金额”
          if (e.value != 'REDUCTION_AMOUNT') {
            // 显示关联按钮
            node.actionBar.linkAction = true;
          }

          props.rowData[node.dataId].equityInformationRule = {
            reductionOption: fullSubRightsOperationOptions[0].value, //活动类型=满减时的优惠操作
            giftOption: fullGwpRightsOperationOptions[0].value, //活动类型=满赠时的优惠操作
            reductionDiscount: fullSubTimesOptions[0].value, //操作类型为满减时的优惠类型
            giftDiscount: fullGwpTimesOptions[0].value, //操作为满赠时的优惠类型
            discountValue: 0, //优惠数值
            giftItemStr: '', // 满赠清单
            equityInfoItemStr: '', // 权益信息清单
            realPriceNotBenefits: true, // 实价产品不让利
            buyItNotBenefits: true, // 一口价产品不让利
            isAdvanced: false, // 是否高级配置
            advanceItemStr: '' // 高级配置清单
          };
        }
      }

      treeGraph!.layout();
    };

    // 权益信息第二列修改
    // @ts-ignore
    window.onRightsInfoCol2Change = (id, e) => {
      const node = treeGraph!.findDataById(id)! as TNodeData;
      activeNode.value = node;

      props.rowData[node.dataId].equityInformationRule[rightsOperationsTimesOptionsKeyMap[node.activityType]] = e.value;
      treeGraph!.layout();
    };

    // 权益信息数值修改
    // @ts-ignore
    window.onRightsInfoNumInput = (id, e) => {
      const node = treeGraph!.findDataById(id)! as TNodeData;
      activeNode.value = node;
      const parts = e.value.split('.');
      if (parts.length > 2) {
        // 有多个小数点，清除额外的小数点
        e.value = parts[0] + '.' + parts.slice(1).join('');
      }
      let ele = document.querySelector(`#rights_${id}`) as HTMLInputElement;

      selectionStart = ele.selectionStart!;
      selectionEnd = ele.selectionEnd!;
      props.rowData[node.dataId].equityInformationRule.discountValue = e.value.replace(/[^\d.]/g, '');
      // @ts-ignore
      window.isRightsInfoSystemBlur = true;
      treeGraph!.layout();

      ele = document.querySelector(`#rights_${id}`) as HTMLInputElement;
      ele.focus(); // 聚焦到number input元素
      ele.setSelectionRange(selectionStart, selectionEnd);
      // @ts-ignore
      window.isRightsInfoSystemBlur = false;
    };

    // 权益信息数值校验
    // @ts-ignore
    window.onRightsInfoNumBlur = (id, e) => {
      const node = treeGraph!.findDataById(id)! as TNodeData;
      // 折扣率不能大于1
      if (
          props.rowData[node.dataId].equityInformationRule.reductionOption === 'DISCOUNT_RATE' &&
          e.value > 1 &&
          // @ts-ignore
          !window.isRightsInfoSystemBlur
      ) {
        Modal.warn({
          title: '提示',
          content: '折扣率不能大于1',
          icon: createVNode(ExclamationCircleOutlined)
        });
        props.rowData[node.dataId].equityInformationRule.discountValue = '';
        treeGraph!.layout();
      }
    };

    return {
      onGroup,
      discountChange,
      canGroup,
      showLinkModal,
      searchLinkStr,
      searchLinkLoading,
      onLinkSearch,
      selectedLinkName,
      showLinkList,
      onLinkChange,
      showPolicyModal,
      onPolicyModalClose,
      onLinkModalClose,
      policyFormRef,
      showRightsSettingModal,
      onRightsSettingClose,
      rightsSettingsFormRef,
      onRightsAdvancedChange,
      onRightsLinkChange,
      isFullScreen,
      showAdvanceSetting,
      showRealPrice,
      showOnePrice,
      activeNode,
      limitNum,
      handleTimeRuleChange,
      validatePlatformDiscount,
      validateProvinceDiscount,
      validateProductDiscount,
      promotionTypeChange
    };
  }
});
